module.exports = __webpack_public_path__ + "img/under-maintenance.81a390f1.svg";